import { ResponsiveSelect } from "../../../../../components/MobileForm";
import { InlineToggle } from "../../../../../components/InlineToggle";
import {
  SORT_OPTIONS,
  sortStateToValue,
  valueToSortState,
} from "../LiabilitiesHoldings";
import { CountLabel, LeftGroup, SelectField, Wrapper } from "./styles";
import { LiabilitiesFiltersProps } from "./types";

export const LiabilitiesFilters: React.FC<LiabilitiesFiltersProps> = ({
  variant,
  isCompact,
  periodValue,
  periodOptions,
  onPeriodChange,
  activeOnly,
  onActiveOnlyChange,
  count,
  total,
  showSort,
  sort,
  onSortChange,
}) => {
  const showCount = variant === "inline";
  const renderSort = showSort && variant === "standalone";
  const countLabel = `${count} of ${total} ${total === 1 ? "liability" : "liabilities"}`;

  const sortValue = sortStateToValue(sort);

  return (
    <Wrapper $variant={variant}>
      <LeftGroup $variant={variant}>
        <SelectField>
          <ResponsiveSelect
            isCompact={isCompact}
            options={periodOptions}
            value={periodValue}
            onChange={(option) => onPeriodChange(option.value)}
            sheetTitle="Select period"
            testId="liabilities-period-filter"
          />
        </SelectField>

        <InlineToggle
          checked={activeOnly}
          onChange={onActiveOnlyChange}
          label="Active only"
          accent="success"
          ariaLabel="Show active liabilities only"
          testId="liabilities-active-only-filter"
        />
      </LeftGroup>

      {renderSort && (
        <ResponsiveSelect
          isCompact={isCompact}
          options={SORT_OPTIONS}
          value={sortValue}
          onChange={(option) => onSortChange(valueToSortState(option.value))}
          sheetTitle="Sort by"
          testId="liabilities-period-sort"
        />
      )}
      {showCount && <CountLabel>{countLabel}</CountLabel>}
    </Wrapper>
  );
};
